// Lightweight password generator backed by the browser's Web Crypto API.
//
// Replaces the `generate-password` npm package, which called `require('crypto')`.
// Under CRA/webpack 4 that pulled the entire ~470KB crypto-browserify polyfill
// tree (elliptic, asn1.js, diffie-hellman, public-encrypt, create-ecdh, ...)
// into the initial bundle on every page, even though only a few random bytes
// were ever needed.

const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const NUMBERS = "0123456789";
const SYMBOLS = "!@#$%^&*()_+-=[]{}|;:,.<>?";

const randomInt = (max) => {
  if (
    typeof window !== "undefined" &&
    window.crypto &&
    window.crypto.getRandomValues
  ) {
    const arr = new Uint32Array(1);
    // Reject the small biased tail so the modulo is uniform.
    const limit = Math.floor(0xffffffff / max) * max;
    let value;
    do {
      window.crypto.getRandomValues(arr);
      value = arr[0];
    } while (value >= limit);
    return value % max;
  }
  return Math.floor(Math.random() * max);
};

export const generate = ({
  length = 10,
  numbers = false,
  symbols = false,
  uppercase = true,
  lowercase = true,
} = {}) => {
  let pool = "";
  if (lowercase) pool += LOWER;
  if (uppercase) pool += UPPER;
  if (numbers) pool += NUMBERS;
  if (symbols) pool += SYMBOLS;
  if (!pool) pool = LOWER + UPPER + NUMBERS;

  let result = "";
  for (let i = 0; i < length; i += 1) {
    result += pool[randomInt(pool.length)];
  }
  return result;
};

export default { generate };
